import { atom } from 'jotai';
import { Product_Naming_Validation_Bool_Exp, Product_Sub_Family_Name_Enum } from '@kheops/graphql';
import { AvailabilityFilterValues } from '../common/ProductAvailabilityFilter';

interface ProductFilters {
  productFamilies: Product_Sub_Family_Name_Enum[];
  query: string;
  page: number;
  availability: AvailabilityFilterValues;
}

export const productFiltersAtom = atom<ProductFilters>({
  productFamilies: [],
  query: '',
  page: 1,
  availability: 'ALL',
});

export type ProductListTab = 'ALL' | 'NAME_TO_OPTIMIZE';

export const productListTabAtom = atom<ProductListTab>('ALL');

// products flagged by the daily naming validation that the user hasn't renamed through the wizard yet
export const PRODUCT_NAME_TO_OPTIMIZE_WHERE: Product_Naming_Validation_Bool_Exp = {
  is_valid: { _eq: false },
  pending_validation: { _eq: false },
};
